export const NEXT_PUBLIC_APOLLO_247_AUTH_URL = process.env.NEXT_PUBLIC_APOLLO_247_AUTH_URL;
export const NEXT_PUBLIC_APOLLO_247_URL = process.env.NEXT_PUBLIC_APOLLO_247_URL;
export const NEXT_PUBLIC_AUTH_TOKEN = process.env.NEXT_PUBLIC_AUTH_TOKEN;
export const NEXT_PUBLIC_INVENTORY_SYNC_URL = process.env.NEXT_PUBLIC_INVENTORY_SYNC_URL;
export const NEXT_PUBLIC_INVENTORY_SYNC_TOKEN = process.env.NEXT_PUBLIC_INVENTORY_SYNC_TOKEN;
export const NEXT_PUBLIC_FIREBASE_PROJECT_ID = process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID;
export const TOKEN_REFETCH_DURATION = 3540000; // 59 minutes
export const INVALID_AUTH_ROUTES = ["/login"];
export const NEXT_PUBLIC_FIREBASE_API_KEY = process.env.NEXT_PUBLIC_FIREBASE_API_KEY;
export const LOGIN_COOKIE_NAME = "logged_in";
export const NEXT_PUBLIC_OAUTH_API = process.env.NEXT_PUBLIC_OAUTH_API;
export const NEXT_PUBLIC_PRIVATE_KEY = process.env.NEXT_PUBLIC_PRIVATE_KEY || "";
export const NEXT_PUBLIC_AUTH_SERVICE = process.env.NEXT_PUBLIC_AUTH_SERVICE;
export const NEXT_PUBLIC_NODE_ENV = process.env.NEXT_PUBLIC_NODE_ENV;
export const NEXT_PUBLIC_MOM_BABY_BASE_PATH = process.env.NEXT_PUBLIC_MOM_BABY_BASE_PATH || "";
export const NEXT_PUBLIC_PHARMACY_BASE_URL = process.env.NEXT_PUBLIC_PHARMACY_BASE_URL;
export const NEXT_PUBLIC_CDN_URL = process.env.NEXT_PUBLIC_CDN_URL;
export const NEXT_PUBLIC_BASE_URL = process.env.NEXT_PUBLIC_BASE_URL;
export const NEXT_PUBLIC_SSR_API_HOST_NAME = process.env.NEXT_PUBLIC_SSR_API_HOST_NAME;
export const NEXT_PUBLIC_API_HOST_NAME = process.env.NEXT_PUBLIC_API_HOST_NAME;
export const NEXT_PUBLIC_PHARMACY_MED_IMAGES_BASE_URL = process.env.NEXT_PUBLIC_PHARMACY_MED_IMAGES_BASE_URL;
export const NEXT_PUBLIC_GATEWAY_API_DOMAIN = process.env.NEXT_PUBLIC_GATEWAY_API_DOMAIN;
export const NEXT_PUBLIC_PATIENT_BASE_URL = process.env.NEXT_PUBLIC_PATIENT_BASE_URL;
export const NEXT_PUBLIC_APOLLO_247_INSURANCE_URL = process.env.NEXT_PUBLIC_APOLLO_247_INSURANCE_URL;
export const LOGIN_POPUP_URL_PARAM = "popup_state";
export const LOGIN_POPUP_URL_STATE = "open_login_popup";
export const NEXT_PUBLIC_PHARMACY_MAGENTO_SSR_BASE_URL = process.env.NEXT_PUBLIC_PHARMACY_MAGENTO_SSR_BASE_URL;
export const NEXT_PUBLIC_PHARMACY_MAGENTO_BASE_URL = process.env.NEXT_PUBLIC_PHARMACY_MAGENTO_BASE_URL;
export const NEXT_PUBLIC_PHARMACY_MED_AUTH_TOKEN = process.env.NEXT_PUBLIC_PHARMACY_MED_AUTH_TOKEN;
export const NEXT_PUBLIC_REDIS_DB = process.env.NEXT_PUBLIC_REDIS_DB;
export const NEXT_PUBLIC_REDIS_HOST = process.env.NEXT_PUBLIC_REDIS_HOST;
export const NEXT_PUBLIC_REDIS_PORT = process.env.NEXT_PUBLIC_REDIS_PORT;
export const REDIS_MAX_AGE = process.env.NEXT_PUBLIC_REDIS_MAX_AGE;